"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("../constant");

var _data = require("../data");

var _default = {
  PropTypes: {
    theme: _propTypes.string,
    invertSearchButtonStyle: _propTypes.bool,
    fireGtm: _propTypes.func,
    endpointConfig: _propTypes.array.isRequired,
    onSubmit: _propTypes.func,
    locale: _propTypes.string,
    geoid: _propTypes.string,
    currency: _propTypes.string,
    enableDataVisor: _propTypes.bool,
    isEdit: _propTypes.bool,
    isLogin: _propTypes.bool,
    customSearchHandler: _propTypes.func,
    agentId: _propTypes.string,
    unifiedListingConfig: _propTypes.object,
    beforeRedirectHandler: _propTypes.func,
    gtmParameters: (0, _propTypes.shape)({
      appName: _propTypes.string
    }),
    domain: _propTypes.string,
    cityLevelGrouping: _propTypes.bool,
    enableOnSearchCookieReset: _propTypes.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    locale: _constant2.DEFAULT_LOCALE,
    geoid: _constant2.DEFAULT_GEOID,
    currency: _constant2.DEFAULT_CURRENCY,
    endpointConfig: _data.ENDPOINT_CONFIG,
    enableDataVisor: false,
    isEdit: false,
    agentId: null,
    invertSearchButtonStyle: false,
    gtmParameters: {
      appName: 'Flights'
    },
    domain: 'com',
    cityLevelGrouping: false,
    enableOnSearchCookieReset: false
  }
};
exports.default = _default;